import React from 'react'
import PageContainer from 'components/page_container/PageContainer'
import ActiveOrdersPage from 'page_active_orders/ActiveOrdersPage'
import CartPage from 'page_cart/CartPage'
import HistoryPage from 'page_history/HistoryPage'
import ProductsPage from 'page_products/ProductsPage'
import ProfilePage from 'page_profile/ProfilePage'
import { Routes, Route, Navigate } from 'react-router-dom'
import TopNavigation from '../top_navigation/TopNavigation'

import {
  PAGE_URL_ACTIVE,
  PAGE_URL_CART,
  PAGE_URL_HISTORY,
  PAGE_URL_CATALOG,
  PAGE_URL_PROFILE,
} from 'SiteURLs'

const MainPage: React.FC = () => {
  return (
    <>
      <TopNavigation />

      <Routes>
        <Route
          path={PAGE_URL_CATALOG}
          element={
            <PageContainer>
              <ProductsPage />
            </PageContainer>
          }
        ></Route>

        <Route
          path={PAGE_URL_ACTIVE}
          element={
            <PageContainer>
              <ActiveOrdersPage />
            </PageContainer>
          }
        ></Route>

        <Route
          path={PAGE_URL_CART}
          element={
            <PageContainer>
              <CartPage />
            </PageContainer>
          }
        ></Route>

        <Route
          path={PAGE_URL_HISTORY}
          element={
            <PageContainer>
              <HistoryPage />
            </PageContainer>
          }
        />
        <Route
          path={PAGE_URL_PROFILE}
          element={
            <PageContainer>
              <ProfilePage />
            </PageContainer>
          }
        />

        <Route
          path='/'
          element={(function () {
            console.log('nav to catalog')
            return <Navigate to={'/' + PAGE_URL_CATALOG} />
          })()}
        />
      </Routes>
    </>
  )
}
export default MainPage
